import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../utils/api";
import { FaUserSecret, FaTimes } from "react-icons/fa";

export default function ImpersonationBanner() {
  const navigate = useNavigate();
  const [stopping, setStopping] = useState(false);

  const impersonation = sessionStorage.getItem("impersonatingUser");
  if (!impersonation) return null;

  const { email } = JSON.parse(impersonation);
  const adminToken = sessionStorage.getItem("adminToken");

  const handleStop = async () => {
    try {
      setStopping(true);
      await apiPost("/api/admin/impersonate/stop", { adminToken });
    } catch (err) {
      console.error("Failed to stop impersonation:", err);
    } finally {
      // Always clear impersonation state and restore admin
      sessionStorage.removeItem("impersonatingUser");
      sessionStorage.removeItem("adminToken");
      localStorage.removeItem("token");
      localStorage.setItem("role", "admin");
      window.location.href = "/admin/users";
    }
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium z-[9999] relative">
      <FaUserSecret size={14} />
      <span>You are viewing as <strong>{email}</strong></span>
      <button
        onClick={handleStop}
        disabled={stopping}
        className="ml-2 px-3 py-1 bg-white text-amber-700 rounded-md text-xs font-semibold hover:bg-amber-50 transition-colors flex items-center gap-1.5"
      >
        <FaTimes size={10} />
        {stopping ? "Stopping..." : "Stop Impersonating"}
      </button>
    </div>
  );
}
